import { useLanguage } from '@/lib/i18n';
import { motion } from 'framer-motion';
import heroBg from '@/assets/via-medica-header.png';

const HeroSection = () => {
  const { tr } = useLanguage();

  const scrollToPlacement = () => {
    const el = document.querySelector('#employers-placement');
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const scrollToAnu = () => {
    const el = document.querySelector('#employers-anu');
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[86vh] md:min-h-[84vh] flex items-center overflow-hidden">
      <img
        src={heroBg}
        alt="Header Hintergrund"
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover z-0"
        style={{ filter: 'contrast(1.25) saturate(1.1) brightness(0.75)' }}
      />

      {/* Overlay fuer bessere Lesbarkeit */}
      <div className="absolute inset-0 w-full h-full bg-black/60 z-0" style={{ mixBlendMode: 'multiply' }} />

      <div className="relative z-10 container mx-auto px-4 py-24 sm:py-28 md:py-36 text-center">
        <div className="max-w-4xl mx-auto rounded-xl md:rounded-none bg-black/50 md:bg-transparent backdrop-blur-[2px] md:backdrop-blur-0 px-4 py-5 sm:px-6 sm:py-6 md:p-0">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/20 border border-primary/40 text-primary-foreground text-xs md:text-sm font-semibold tracking-wide"
            style={{ textShadow: '0 1px 8px rgba(0,0,0,0.7)' }}
          >
            {tr('hero.positioning')}
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mt-4 font-heading text-[1.7rem] sm:text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground leading-tight drop-shadow-2xl"
            style={{ textShadow: '0 4px 18px rgba(0,0,0,0.85)' }}
          >
            {tr('hero.title')}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-5 md:mt-6 text-[0.98rem] md:text-lg lg:text-xl text-primary-foreground/95 max-w-2xl mx-auto font-body font-medium leading-relaxed"
            style={{ textShadow: '0 2px 12px rgba(0,0,0,0.8)' }}
          >
            {tr('hero.subtitle')}
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="mt-3 md:mt-4 text-[0.95rem] md:text-base lg:text-lg text-primary-foreground/90 max-w-2xl mx-auto font-body font-normal leading-relaxed"
            style={{ textShadow: '0 1px 8px rgba(0,0,0,0.7)' }}
          >
            {tr('hero.intro')}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center"
          >
            <button
              onClick={scrollToAnu}
              className="px-8 py-4 bg-primary text-primary-foreground font-semibold rounded-lg shadow-lg hover:opacity-90 transition-opacity text-sm md:text-base"
            >
              {tr('hero.cta.anu')}
            </button>

            <button
              onClick={scrollToPlacement}
              className="px-8 py-4 bg-primary-foreground/10 border border-primary-foreground/50 text-primary-foreground font-semibold rounded-lg shadow-lg hover:bg-primary-foreground/20 transition-colors text-sm md:text-base"
            >
              {tr('hero.cta.placement')}
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3 max-w-3xl mx-auto"
          >
            <div className="rounded-lg border border-primary-foreground/30 bg-black/30 p-4 text-left">
              <p className="text-xs md:text-sm font-semibold uppercase tracking-wide text-primary-foreground/80">{tr('hero.compare.anu.title')}</p>
              <p className="mt-2 text-sm md:text-base text-primary-foreground/95 leading-relaxed">{tr('hero.compare.anu.desc')}</p>
            </div>

            <div className="rounded-lg border border-primary-foreground/30 bg-black/30 p-4 text-left">
              <p className="text-xs md:text-sm font-semibold uppercase tracking-wide text-primary-foreground/80">{tr('hero.compare.placement.title')}</p>
              <p className="mt-2 text-sm md:text-base text-primary-foreground/95 leading-relaxed">{tr('hero.compare.placement.desc')}</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

